import React from 'react';
const legalLinks = [{
  label: 'Política de privacidad',
  href: '#politica-privacidad'
}, {
  label: 'Términos y condiciones',
  href: '#terminos'
}, {
  label: 'Política de reembolso',
  href: '#politica-reembolso'
}];
export function FooterSection() {
  return <footer className="bg-sand-deep py-10 md:py-12 px-4" data-hide-sticky data-id="element-70" data-mp="3h6enbl2ylzko">
      <div className="max-w-3xl mx-auto text-center" data-id="element-71" data-mp="3cah7rgzisx8y">
        <p className="font-serif text-2xl font-bold text-forest" data-id="element-72" data-mp="2ojll0y9x8s8k">Pausa Propia</p>
        <p className="font-sans text-sm text-forest/70" data-id="element-73" data-mp="2kii2g40hoi3n">por Nerovix</p>

        <p className="mt-5 font-sans text-[13px] text-forest/75 leading-[1.6] max-w-xl mx-auto" data-id="element-74" data-mp="2kgf5t14tzqpy">
          Producto digital educativo de bienestar, creatividad, expresión emocional y
          autoconocimiento. No constituye diagnóstico, psicoterapia ni tratamiento médico.
        </p>

        <nav aria-label="Enlaces legales" className="mt-6" data-id="element-75" data-mp="25rsr91n132zs">
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 font-sans text-sm font-medium text-forest" data-id="element-76" data-mp="20vaqsdyqdqt9">
            {legalLinks.map(link => <li key={link.href} data-id="element-77" data-mp="1gevnd87qpb7e">
                <a href={link.href} className="underline-offset-2 hover:underline" data-id="element-78" data-mp="1lf9oe6axbkvx">
                  {link.label}
                </a>
              </li>)}
            <li data-id="element-79" data-mp="1q8vqj4jgo6dh">
              <a href="mailto:soporte.nerovix@gmail.com" className="underline-offset-2 hover:underline" data-id="element-80" data-mp="1v5cmum0tdr1n">
                soporte.nerovix@gmail.com
              </a>
            </li>
          </ul>
        </nav>

        <p className="mt-6 font-sans text-xs text-forest/60" data-id="element-81" data-mp="12gf6wpk2s6c2">
          © 2026 Nerovix. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}